import { Navigate } from "react-router";
import Main from "./Main";

function PrivateRoute({ children, ...rest }) {
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/login" />;

  return <Main {...rest}>{children}</Main>;
}

export default PrivateRoute;
